export default "__VITE_ASSET__CSRE9qty__"